import { format } from 'date-fns';

import type { AiDataPolicyValue } from './types';

export function policyValueKey(value: AiDataPolicyValue): string {
  switch (value) {
    case 'investbanq_only':
      return 'values.investbanqOnly';
    case 'commercial_allowed':
      return 'values.commercialAllowed';
    default:
      return 'values.notChosen';
  }
}

function parsed(iso: string | null | undefined): Date | null {
  if (!iso) return null;
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatPolicyDate(iso: string | null | undefined): string {
  const date = parsed(iso);
  return date ? format(date, 'MMM d, yyyy') : '';
}

export function formatPolicyTime(iso: string | null | undefined): string {
  const date = parsed(iso);
  return date ? format(date, 'HH:mm') : '';
}

export function formatPolicyDateTime(iso: string | null | undefined): string {
  const date = parsed(iso);
  return date ? format(date, 'MMM d, yyyy, HH:mm') : '';
}
